/** Mirrors the backend default for MEDIA_MAX_BYTES; a larger file is refused with 413 anyway. */
export const MAX_MEDIA_BYTES = 25 * 1024 * 1024;

/** The backend caps `alt` at 500 characters (`packages/schemas/src/media.ts`). */
export const MAX_MEDIA_ALT_LENGTH = 500;

/** The backend caps an edited image's sides at this (`MEDIA_EDIT_MAX_DIMENSION`). */
export const MAX_MEDIA_EDIT_DIMENSION = 6000;
